import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import type { PersonalDataField } from "web_myplann/Profile/Types/PersonalDataField";
import { FlatRowInput } from "web_myplann/Shared/Components/FlatRow/FlatRowInput";

type Props = {
	fields: PersonalDataField[];
};

export const PersonalDataList: FC<Props> = ({ fields }) => {
	const theme = useTheme();

	return (
		<Stack bgcolor={theme.palette.background.paper}>
			{fields.map((field, index) => (
				<FlatRowInput
					key={field.id}
					label={field.label}
					value={field.value ?? ""}
					readOnly
					isLast={index === fields.length - 1}
				/>
			))}
		</Stack>
	);
};
